// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__i0EKQ","title":"Images90_title__3JIwe","images":"Images90_images__2cyNw"};